import React, { FC, useState } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { getDisplayDate } from 'src/app/common/utils/time-utils';
import { PaginateListMore } from 'src/app/common/types/common-types';
import PruTable from 'src/app/common/components/PruTable/PruTable';
import {
  BDM_PROMOTION_BASE_PATH,
  BDM_TEMPLETE_BASE_PATH,
  SALESKIT_BASE_PATH,
} from 'src/app/modules/sales-kit/constants';
import { PromotionImageItem, PromotionImageFormMode } from '../../../types/promotion-image-type';
import { Dialog } from '@mui/material';
import { useStyles } from '../../../styles/promotion-image-style';

type PromotionImageListProps = {
  isLoading: boolean;
  itemList?: PaginateListMore<PromotionImageItem>;
  onRefresh: () => void;
  onChangePage: (page: number, rowsPerPage: number) => void;
};

const PromotionImageList: FC<PromotionImageListProps> = ({ isLoading, itemList, onRefresh, onChangePage }) => {
  const history = useHistory();
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const { classes } = useStyles();
  const [isShowPreview, setShowPreview] = useState<any>(false);
  const [imagePreview, setImagePreview] = useState<any>();

  return (
    <>
      <PruTable
        title={Translation('title.resource.bdm.promotion') + ' List'}
        headerBtnDef={[
          {
            color: 'primary',
            title: Translation('app.button.add'),
            onClick: () =>
              history.push(`${SALESKIT_BASE_PATH}${BDM_TEMPLETE_BASE_PATH}${BDM_PROMOTION_BASE_PATH}/create`, {
                type: PromotionImageFormMode.CREATE,
              }),
          },
        ]}
        disableBulkSelect
        operationDef={[
          {
            title: Translation('app.button.view'),
            tooltipText: 'View',
            onClick: (row) => {
              setImagePreview(row.image.url);
              setShowPreview(true);
            },
            condition: () => true,
          },
          {
            title: Translation('app.button.edit'),
            tooltipText: 'Edit',
            onClick: (row) =>
              history.push(`${SALESKIT_BASE_PATH}${BDM_TEMPLETE_BASE_PATH}${BDM_PROMOTION_BASE_PATH}/edit/${row._id}`, {
                type: PromotionImageFormMode.EDIT,
              }),
            condition: (_) => true,
          },
        ]}
        columnDef={[
          {
            keyIndex: 'name',
            displayName: 'Name',
            renderData: (row) => row.name || '',
          },
          {
            keyIndex: 'lastUpdatedDate',
            align: 'center',
            displayName: Translation('component.formLabel.updated-time'),
            renderData: (row) => (row.updatedAt ? getDisplayDate(new Date(row.updatedAt), 'DD/MM/YYYY HH:mm') : ''),
          },
        ]}
        isLoading={isLoading}
        onRefresh={onRefresh}
        dataSource={itemList?.items}
        totalPages={itemList?.totalPages}
        totalRecords={itemList?.totalRecords}
        onChangePage={onChangePage}
      />
      <Dialog
        onClose={() => {
          setShowPreview(false);
        }}
        open={isShowPreview}
        style={{ backgroundColor: 'transparent' }}
      >
        <div className={classes.popupContent}>
          <img src={imagePreview} className={classes.popupImage} alt="template img" />
        </div>
      </Dialog>
    </>
  );
};

export default PromotionImageList;
